import React from 'react';
import { BorderedDiv } from '../../../layout';
import theme from '../../../theme';
import { Venus } from '../../../typography';

const Warning = ({ children, ...rest }) => {
  return (
    <BorderedDiv
      fill={theme.colors.warning.light}
      border={`1px solid ${theme.colors.primary.dark}`}
      {...rest}
    >
      <Venus lineHeight='1.4rem' color={theme.colors.primary.dark}>
        {children}
      </Venus>
    </BorderedDiv>
  );
};

export default Warning;
